import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PointsService {
  public apiBaseUrl: string;
  public endpoint = 'points';

  constructor(private readonly http: HttpClient) {
    const config = JSON.parse(sessionStorage.getItem('globalConfig'));
    this.apiBaseUrl = config.apiGatewayBaseUrl + '/api/v1';
  }

  private get url(): string {
    return `${this.apiBaseUrl}/${this.endpoint}`;
  }

  /**
   * Set the point as read
   * @param pointsIds
   */
  public markPointsAsRead(pointsIds: number | number[]): void {
    this.http
      .post<unknown>(`${this.url}/markasreaded`, {
        pointIds: Array.isArray(pointsIds) ? pointsIds : [pointsIds],
      })
      .subscribe();
  }
}
